import React, { useState } from "react";
import { useParams } from "react-router-dom";
import PageContent from "../Components/Content";
import { usePageTitle } from "../Utilities/usePageTitle";


const Page = () => {
    const { url } = useParams();
    const [pageTitle, setPageTitle] = useState('');
    usePageTitle(pageTitle);

    return (
        <div className="container py-4">
            <div className="page-content">
            <PageContent furl={url} onTitle={setPageTitle} />
            </div>
        </div>
    )
}

export default Page;
